import { mapState } from 'vuex';
export default {
  name: 'CoreVirtualDeviceMonitoringCard',
  props: {
    id: {
      type: Number,
      required: true
    },
    account: {
      type: String,
      required: true
    },
    title: {
      type: String,
      required: true
    },
    devices: {
      type: [Number, String],
      default: 0
    },
    errors: {
      type: [Number, String],
      default: 0
    },
    warnings: {
      type: [Number, String],
      default: 0
    },
    tags: {
      type: Array,
      default: () => []
    },
    actions: {
      type: Array,
      default: () => []
    }
  },
  data: function () {
    return {};
  },
  computed: {
    ...mapState('app', ['color', 'inpOutlined', 'inpFilled']),
    canDelete() {
      return this.actions.includes('delete');
    },
    // if feature-flag `rd-6855` is disabled, there still is an EDIT view, rather than just create
    canEdit() {
      return this.actions.includes('edit');
    }
  },
  watch: {},
  methods: {
    openMonitoringView(id, state) {
      this.$router.push(`/virtual-device-groups/${id}?tab=${state}`);
    },
    openMapview(id) {
      this.$router.push({
        path: '/virtual-device-groups/map',
        query: {
          view: id,
          mode: 'devices'
        }
      });
    },
    handleDelete(event) {
      event.target.blur();
      this.$emit('delete', this.id);
    },
    // if feature-flag `rd-6855` is disabled, there still is an EDIT view, rather than just create
    handleEdit(event) {
      event.target.blur();
      this.$emit('edit', this.id);
    }
  }
};